import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { openAthensSSODispatchers as stateProps } from '../../redux/modules/app/dispatchers'

function OpenAthensSSO(props) {
  const location = useLocation()

  useEffect(() => {
    const query = Object.fromEntries(new URLSearchParams(location.search))
    props.openAthensSSODispatcher({ ...props, location: { ...location, query } })
  }, [])

  return <div id="OpenAthensSSO" />
}

export default connect(null, stateProps)(OpenAthensSSO)
